import { Diagram } from '../diagram'
import { isDataCheckAction, isEmailAction, isSlackAlertAction, TypedNode } from '../node/types'
import DolfinRecord from '../record'
import { DolfinRpc } from '../rpc'
import { NodeError, NodeWarning } from '../types'
import { DataCheckAction } from './data-quality/check'
import { EmailMessagingAction } from './messaging/email'
import SlackMessageAction from './messaging/slack'

export type AnyAction = DataCheckAction | SlackMessageAction | EmailMessagingAction

export class ActionsFactory {
  static create(
    node: TypedNode<'custom-check'>,
    record: DolfinRecord,
    organizationId: number,
    rpcClient: DolfinRpc
  ): AnyAction | null {
    if (isSlackAlertAction(node)) {
      return new SlackMessageAction(node, record, organizationId, rpcClient)
    }
    if (isEmailAction(node)) {
      return new EmailMessagingAction(node, record, organizationId, rpcClient)
    }
    if (isDataCheckAction(node)) {
      return new DataCheckAction(node, record, organizationId, rpcClient)
    }

    return null
  }

  static validate(
    node: TypedNode<'custom-check'>,
    diagram: Diagram
  ): {
    errors: NodeError[]
    warnings: NodeWarning[]
  } {
    if (isSlackAlertAction(node)) {
      return SlackMessageAction.validate(node, diagram)
    }
    if (isEmailAction(node)) {
      return EmailMessagingAction.validate(node, diagram)
    }
    if (isDataCheckAction(node)) {
      return DataCheckAction.validate(node, diagram)
    }
    return {
      errors: [],
      warnings: []
    }
  }
}
